import { FiLinkedin, FiGithub, FiMail } from "react-icons/fi";
import { personalInfo } from "../data/personalInfo";
import "./Footer.css";

const navLinks = [
  { label: "About", href: "#about" },
  { label: "Projects", href: "#projects" },
  { label: "Experience", href: "#experience" },
  { label: "Skills", href: "#skills" },
];

const socials = [
  { icon: FiLinkedin, href: personalInfo.linkedin, label: "LinkedIn" },
  { icon: FiGithub, href: personalInfo.github, label: "GitHub" },
  { icon: FiMail, href: `mailto:${personalInfo.email}`, label: "Email" },
];

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer__inner">
        <div className="footer__identity">
          <a href="#hero" className="footer__name">
            <span className="footer__name-accent">A</span>mritpreet Singh
          </a>
          <p className="footer__tagline">
            Full-Stack Developer building scalable web solutions.
          </p>
        </div>

        <nav className="footer__nav" aria-label="Footer navigation">
          {navLinks.map((link) => (
            <a key={link.href} href={link.href} className="footer__nav-link">
              {link.label}
            </a>
          ))}
        </nav>

        <div className="footer__socials">
          {socials.map(({ icon: Icon, href, label }) => (
            <a
              key={label}
              href={href}
              target={label !== "Email" ? "_blank" : undefined}
              rel={label !== "Email" ? "noopener noreferrer" : undefined}
              className="footer__social"
              aria-label={label}
            >
              <Icon size={17} />
            </a>
          ))}
        </div>

        <div className="footer__bottom">
          <span>&copy; {new Date().getFullYear()} Amritpreet Singh</span>
        </div>
      </div>

    </footer>
  );
};

export default Footer;
